import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../../../common/AutoBindComponent";
import unsavedDataDialogHandler from "../../../common/UnsavedDataDialogHandler";
import * as DomainConstants from "../../../../constants/DomainConstants";
import { uploadOneFile, deleteOneFile } from "../../../common/DownloadUploadFilesHelper";

import * as layoutActions from "../../../../actions/layoutActions";
import * as documentActions from "../../../../actions/documentActions";
import * as beads from "../../../../actions/beadActions";
import convertToLabelValuePair from "../../../../util/convertToLabelValuePair.js";

import FinancierEditForm from "./FinancierEditForm";
import FinancierEditPageHelper from "./FinancierEditPageHelper";
import * as types from "../../../../constants/ComponentConstants";

class FinancierEditPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            model: {},
            validationMessages: {},
            documenten: [],
            sjablonen: [],
            fileSessionStarted: false,
            hasUnsavedChanges: false,
            aanvragers: []
        };

        this.pageHelper = new FinancierEditPageHelper(this);
    }

    componentWillMount() {
        this.pageHelper.init();
    }

    handleOnSave() {
        this.pageHelper.save();
    }

    handleOnClose() {
        this.pageHelper.goToOverview();
    }

    handleOnChange(event) {
        this.pageHelper.change(event);
    }

    handleOnDropFiles(component, files) {
        const gevondenDocumenten = this.state.documenten.find(x => x.name === component);

        if (gevondenDocumenten != null && gevondenDocumenten.files.length > 0) {
            const fileName = gevondenDocumenten.files[0].name;
            this.pageHelper.handleFileRequest(component, fileName, () => { deleteOneFile(this, this.props.deleteDocument, this.props.dossierId, DomainConstants.DocumentTab.FinancieelSubtabFinanciering, component, fileName); });
        }

        this.pageHelper.handleFileRequest(component, files, () => { files.forEach(file => uploadOneFile(this, this.props.uploadDocument, this.props.dossierId, DomainConstants.DocumentTab.FinancieelSubtabFinanciering, component, file)); });
    }

    handleOnDeleteFile(component, fileName) {
        this.pageHelper.handleFileRequest(component, fileName, () => { deleteOneFile(this, this.props.deleteDocument, this.props.dossierId, DomainConstants.DocumentTab.FinancieelSubtabFinanciering, component, fileName); });
    }

    render() {
        const financiers = convertToLabelValuePair(this.state.aanvragers);

        const isDisabled = this.state.dossierRedenVanStatus ? this.state.dossierRedenVanStatus.toString() === DomainConstants.REDEN_VAN_STATUS_INGEDIEND : false;

        return (<FinancierEditForm
            model={this.state.model}
            errors={this.state.validationMessages}
            validationMessages={this.state.validationMessages}
            color={types.COLOR_PINK_LIGHT}
            financiers={financiers}
            onBewaarClick={this.handleOnSave}
            onSluitClick={this.handleOnClose}
            onChange={this.handleOnChange}
            disabled={isDisabled}
            documenten={this.state.documenten}
            sjablonen={this.state.sjablonen}
            onDropFiles={this.handleOnDropFiles}
            onDeleteFile={this.handleOnDeleteFile}
            fileSessionStarted={this.state.fileSessionStarted}
            bewijsVanFinancierURL={this.props.bewijsVanFinancierURL}
            totaleInvestering={this.state.totaleInvestering}
            dossierId={this.state.dossierId}
            fileTypes={this.props.fileTypes}
        />);
    }
}

function mapStateToProps(state, ownProps) {
    const dossierId = ownProps.params.dossierId;

    return {
        dossierId: dossierId,
        bewijsVanFinancierURL: state.settings.bewijsVanFinancierURL,
        fileTypes: state.settings.fileTypes
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadFinancierEditPageLayout, dispatch),
        uploadDocument: bindActionCreators(documentActions.uploadDocument, dispatch),
        deleteDocument: bindActionCreators(documentActions.deleteDocument, dispatch),
        startFileSession: bindActionCreators(documentActions.startFileSession, dispatch),
        endFileSession: bindActionCreators(documentActions.endFileSession, dispatch),
        getContent: bindActionCreators(documentActions.getContent, dispatch),
        getSjablonen: bindActionCreators(documentActions.getSjablonen, dispatch),
        beadsLoaded: bindActionCreators(beads.beadsLoaded, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(FinancierEditPage));